angular.module('service-request')
    .component('serviceRequestTable', {
        bindings: {
            projectId: '<',
            query: '<',
            onDataLoaded: '&',
        },
        templateUrl: 'app/service-request/table.html',
        controller($scope, $state, Project, ProjectService, ServiceRequest, ServiceRequestConst) {
            this.ProjectService = ProjectService;

            this.$onChanges = () => {
                ServiceRequest.table({project: this.projectId, search: this.query}).$promise.then(data => {
                    this.page = data;
                    if (angular.isFunction(this.onDataLoaded)) {
                        this.onDataLoaded({$page: this.page});
                    }
                });
            }

            $scope.$on(ServiceRequestConst.eventUpdate, () => this.$onChanges())
        }
    })
